/* eslint-disable import/prefer-default-export */
export type SeverityMessage = 'error' | 'warning' | 'success' | 'info'

export const iconMessageNames: { [key in SeverityMessage]: string } = {
  error: 'cancel',
  success: 'check_circle',
  warning: 'warning',
  info: 'info'
}
